import MarketplaceHeader from './MarketplaceHeader';
import MarketplaceFooter from './MarketplaceFooter';

export default function MarketplaceLayout({ children }) {
  return (
    <div className="marketplace-theme">
      <MarketplaceHeader />
      <main>{children}</main>
      <MarketplaceFooter />
    </div>
  );
}
